// src/services/protocoloService.js
import api from './api';

/**
 * Protocolo de entrada de requerimento (chamado ESS-IBE-2026-0005).
 *
 * Diferente dos services mais antigos, este preserva o `fieldErrors` que a
 * API devolve: a tela precisa destacar o campo errado, e não só repetir
 * "dados inválidos".
 */
const montarErro = (error, mensagemPadrao) => {
  console.error(mensagemPadrao, error);

  const dados = error.response?.data;
  if (dados) {
    const erro = new Error(dados.message || dados.error || mensagemPadrao);
    erro.fieldErrors = dados.fieldErrors || null;
    erro.status = error.response.status;
    return erro;
  }

  return new Error('Erro de conexão. Tente novamente.');
};

const protocoloService = {
  list: async (params = {}) => {
    try {
      const response = await api.get('/protocolos', { params });
      return response.data;
    } catch (error) {
      throw montarErro(error, 'Não foi possível buscar os protocolos');
    }
  },

  getById: async (id) => {
    try {
      const response = await api.get(`/protocolos/${id}`);
      return response.data;
    } catch (error) {
      throw montarErro(error, 'Não foi possível buscar o protocolo');
    }
  },

  /** Catálogo de tipos — a tela monta o select a partir daqui, sem duplicar a regra. */
  listarTipos: async () => {
    try {
      const response = await api.get('/protocolos/tipos');
      return response.data;
    } catch (error) {
      throw montarErro(error, 'Não foi possível buscar os tipos de requerimento');
    }
  },

  /** Estado da sequência: qual será o próximo número e qual o piso para ajuste. */
  lerSequencia: async () => {
    try {
      const response = await api.get('/protocolos/sequencia');
      return response.data;
    } catch (error) {
      throw montarErro(error, 'Não foi possível ler a sequência de protocolos');
    }
  },

  /** Acerto do corte com o livro de papel. */
  ajustarSequencia: async (proximoNumero) => {
    try {
      const response = await api.patch('/protocolos/sequencia', { proximoNumero });
      return response.data;
    } catch (error) {
      throw montarErro(error, 'Não foi possível ajustar a sequência');
    }
  },

  create: async (dados) => {
    try {
      const response = await api.post('/protocolos', dados);
      return response.data;
    } catch (error) {
      throw montarErro(error, 'Não foi possível registrar o protocolo');
    }
  },

  update: async (id, dados) => {
    try {
      const response = await api.put(`/protocolos/${id}`, dados);
      return response.data;
    } catch (error) {
      throw montarErro(error, 'Não foi possível atualizar o protocolo');
    }
  },

  /** Não existe exclusão: o número fica queimado, como a rasura no livro. */
  anular: async (id, motivo) => {
    try {
      const response = await api.patch(`/protocolos/${id}/anular`, { motivo });
      return response.data;
    } catch (error) {
      throw montarErro(error, 'Não foi possível anular o protocolo');
    }
  }
};

export default protocoloService;
